export class KanbanToggle {
  labelBefore: string;
  labelAfter: string;
  value: boolean;
  sessionsSettingsProperty: string;
}